<template>
  <div>
    <AppHeader  />
    <div
      class="activity"
    >
      <div v-if="loaded" class="activity__preview">
        <img
          :src="getActivity.image"
          class="activity__preview-background"
        />
        <v-container>
          <!--          <div-->
          <!--            class="activity__preview-background"-->
          <!--            :style="{ 'background-image': 'url(' + getActivity.image + ')' }"-->
          <!--          />-->
          <v-layout
            class="activity__preview-content"
            align-center
            column
            justify-center
          >
            <h1 class="activity__preview-title">
              {{ getActivity.name }}
            </h1>
              <p class="activity__preview-text">
              <!-- 1 {{getActivity.input}} = {{getActivity.miles_equivalent}} nmg miles = {{getActivity.zar_raised}} zar -->
              1 {{getActivity.input}} = {{getActivity.miles_equivalent}} nmg miles
              </p>
            <p class="activity__preview-text">

          <!--    Most tracked<br> activity-->
            </p>
            <div class="text-xs-center">
              <v-menu offset-y class="activity-menu" max-height="600">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="teal lighten-2"
                    class="white--text"
                    round
                    large
                  >
                    Other activity
                    <i class="fas fa-chevron-down ml-2" />
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    class="activity-list"
                    v-for="activity in getActivities"
                    :key="activity.id"
                  >
                    <v-list-tile-title
                      :data-activity-id="activity.id"
                      @click="redirectToActivity"
                    >
                      {{ activity.name }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </v-layout>
        </v-container>
      </div>

      <v-container v-if="loaded">
        <v-layout
          class="activity__enter-stats"
          row
        >
          <v-flex
            md12
          >
            <h2
              class="app-title"
            >
              Enter activity details
            </h2>
            <div
              class="actitvity-track"
            >
              <!--            <div-->
              <!--              class="actitvity-track__label mr-3"-->
              <!--            >-->
              <!--              -->
              <!--            </div>-->
              <v-text-field
                v-model="points"
                :label="getActivity.input"
                :error-messages="getError['points']"
                required
                outline
                color="teal lighten-2"
                class="actitvity-track__input round theme pl-2 pr-2"
              />
              <v-btn
                class="actitvity-track__button white--text"
                large
                color="red darken-3"
                round
                @click="track"
              >
                Track
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex md12>
            <h3 class="app-title">Select date</h3>
            {{ getError['date_record'] }}

            <!--            <v-btn @click="changeCalendarType('week')">-->
            <!--              <i class="fas fa-grip-lines" /> Week-->
            <!--            </v-btn>-->
            <!--            <v-btn @click="changeCalendarType('month')">-->
            <!--              <i class="fas fa-grip-horizontal" /> Month-->
            <!--            </v-btn>-->

            <!--            <br>-->
            <!--            <br>-->

            <!--<v-calendar ref="calendar" v-model="start" :type="type" :end="end"></v-calendar>-->
            <v-date-picker
              class="datepick"
              v-model="picker"
              :max="maxPickerDate"
              width=false
              color="red lighten-1"
            />
            <br><br><br>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex md12>
            <h3 class="app-title">Notes</h3>
            {{ getError['notes'] }}

            <v-textarea
              color="teal lighten-2"
              v-model="notes"
              outline
            />
          </v-flex>
        </v-layout>
      </v-container>
          <div v-else class="text-xs-center">

            <v-progress-linear :indeterminate="true"></v-progress-linear>

    </div>
      <v-dialog
        v-model="successModal"
        fullscreen
        hide-overlay
        dark
        transition="dialog-bottom-transition"
        class="activity-dialog-success"
      >
        <div class="activity-dialog-success__inner">
          <v-toolbar
            dark
            color="dark"
            class="elevation-0"
          >
            <!--<v-btn
              icon
              dark
              @click="successModal = false"
            >

              <v-icon>
                close
              </v-icon>
            </v-btn>-->
          </v-toolbar>
          <div class="activity-dialog-success__content">
            <div class="activity-dialog-success__body">
              <h3
                class="activity-dialog-success__title"
              >
                Thanks for<br>
                tracking
              </h3>
              <p
                class="activity-dialog-success__text"
              >
                Way to go!
              </p>
              <i class="activity-dialog-success__icon fas fa-thumbs-up"/>
            </div>
            <div class="activity-dialog-success__footer">
              <v-btn
                v-if="this.getTopActivity"
                outline
                round
                large
                color="teal lighten-2"
                class="success_buttons"
                @click="closeSuccessModal"
              >
                Track Another Activity
              </v-btn>
              <router-link
                to="/activities">
                <v-btn
                  outline
                  round
                  large
                  color="teal lighten-2"
                  class="success_buttons"
                  :to="{ name: 'user', params: { id: this.uud }}"
                >
                  Back to my profile
                </v-btn>
              </router-link>
            </div>
          </div>
        </div>
      </v-dialog>
      <BottomNavigation />
    </div>
  </div>
</template>

<script>
  import AppHeader from '../components/AppHeader';
  import BottomNavigation from "../components/BottomNavigation";
  import { mapGetters } from "vuex";
  // import { ACTIVITIES_REQUEST } from "../store/actions/activities";
  //import { ACTIVITY_REQUEST } from "../store/actions/activity";
  import moment from "moment";

  export default {
    name: "Activity",
    components: {
      AppHeader,
      BottomNavigation
    },
    data() {
      return {
        maxPickerDate: new Date().toISOString().substr(0, 10),
        successModal: false,
        loaded: false,
        points: "",
        errors: {},
        picker: new Date().toISOString().substr(0, 10),
        notes: "",
        activityId: this.$route.params.id,
      };
    },
    computed: {
      ...mapGetters(
        'activity', ['getActivities', 'getActivity', 'getError', 'getTopActivity'],
      ),
            ...mapGetters(
        'user', ['getCurrentUser'],
      ),
      uud: function(){
        return localStorage.getItem('user_id');
      }
      //currentActivity: function () {
      //  return this.getActivityById;
      //  // return this.$store.getters.getActivityById(this.activityId);
      // }
    },
    mounted() {
      const act_id = this.$route.params.id;
      this.$store.dispatch('activity/activityRequest', { act_id }).then(() => {
          this.loaded = true;
          })
          .catch(err => {
            
            });
      this.$store.dispatch('activity/activitiesRequest');
    },
    methods: {
      redirectToActivity: function (event) {
        const activityId = parseInt(event.target.dataset.activityId, 10);
        this.activityId = activityId;
        const act_id = this.activityId;
        this.$store.dispatch('activity/activityRequest', {  act_id });
        this.$router.push(`/activity/${this.activityId}`);
      },
      //changeCalendarType: function (type) {
      //   this.type = type;
      // },
      track: function () {
        const date_record = moment(this.picker).format("YYYY-MM-DD");
        const activity_id = this.activityId;
        const { points, notes } = this;

        this.$store
          .dispatch('activity/updateActivity', { activity_id, points, date_record, notes })
          .then(() => {
            // this.$router.push("/activities");
            this.successModal = true;
          })
        //  .catch(err => {
        //   });
      },
      closeSuccessModal: function () {
        this.points = "";
        this.$store.dispatch('activity/activityRequest', { act_id: this.activityId });
        this.successModal = false;
      }
    }
  };
</script>

<style scoped>
  .activity {
    padding-bottom: 100px;
  }

  .activity__preview {
    position: relative;
    height: 200px;
    display: flex;
    color: #fff;
    text-align: center;
    /*margin-bottom: 10px;*/
  }

  .activity-menu {
    z-index: 151;
  }

  .activity-list {
    cursor: pointer;
  }

  .activity-list:hover {
    background-color: darkgrey;
  }

  .activity__preview-background {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
    z-index: 1;
    filter: brightness(50%);
    -webkit-filter: brightness(50%);
  }

  .activity__preview-content {
    position: relative;
    z-index: 2;
  }


  .activity__preview-title {
    position: relative;
    font-size: 24px;
    font-weight: bold;
    padding-bottom: 5px;
    margin-bottom: 10px;
  }

  .activity__preview-title::after {
    display: block;
    content: '';
    width: 30px;
    height: 1px;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    left: calc(50% - 15px);
  }

  .activity__preview-text {
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 2.1px;
    line-height: 20px;
  }

  .activity__enter-stats {
    margin-bottom: 0px;
  }

  .actitvity-track {
    display: flex;
    align-items: flex-start;
  }

  .actitvity-track__label {
    position: relative;
    font-size: 15px;
    top: -12px;
    padding-left: 12px;
  }

  .actitvity-track__input {
    /*max-width: 120px;*/
  }

  .actitvity-track__button {
    margin: 0;
    height: 56px;
  }

  .activity-dialog-success {

  }

  .activity-dialog-success__inner {
    /*min-height: 100vh;*/
    background-color: #212121;
  }

  .activity-dialog-success__content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    min-height: calc(100vh - 56px);
    text-align: center;
    color: #fff;
    padding-bottom: 40px;
  }

  .activity-dialog-success__title {
    position: relative;
    font-size: 30px;
    line-height: 35px;
    padding: 50px 0 15px 0;
    margin-bottom: 15px;
  }

  .activity-dialog-success__title::after {
    position: absolute;
    bottom: 0;
    left: calc( 50% - 25px);
    display: block;
    content: '';
    width: 50px;
    height: 1px;
    background-color: #fff;
  }

  .activity-dialog-success__text {
    font-size: 18px;
    margin-bottom: 60px;
  }

  .activity-dialog-success__footer {
    display: inline-grid;
    text-decoration: underline;
    text-decoration-color: #4db6ac;
  }

  .success_buttons {
    width: 100%;
  }

  .activity-dialog-success__icon {
    display: block;
    width: 168px;
    height: 168px;
    line-height: 160px;
    border: 1px solid #d00024;
    border-radius: 100%;
    font-size: 60px;
    color: #d00024;
    margin-bottom: 60px;
  }
 .datepick {
   display: flex;
 }
</style>
